import MediaQueries from "@libs/media-queries";

// Note - it is up to you to synchronise this with
// the screens in tailwind, if you want consistency.
const screens = {
	mobileshelf: { max: '1023px' },
	mobileonly: { max: '1023px' },
	belowmd: { max: '768px' },
	sm: { min: '640px' },
	md: { min: '768px' },
	lg: { min: '1024px' },
	xl: { min: '1441px' },
	xl2: { min: '1600px' },
};

export const media = new MediaQueries( screens );
export default { media };
